import {resolveHelpURL} from '../../../../utils/url'

export const whatsNewHref: string = resolveHelpURL('what-s-new-in-teamcity.html')
export const aboutSakuraUIHref: string = resolveHelpURL('teamcity-sakura-ui.html')
